"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _IconErrorOutline = _interopRequireDefault(require("../../icons/General/IconErrorOutline"));
var _styles = require("./styles");
var _jsxRuntime = require("@emotion/react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** @jsxImportSource @emotion/react */

// import { useRef, useState, useEffect } from 'react'
// import { Modifier, Modifiers } from 'react-day-picker'
// import DayPickerInput from 'react-day-picker/DayPickerInput'
// import { useIsMobile } from '../..'

// import {
//   formatDate,
//   MONTHS,
//   parseDate,
//   WEEKDAYS_LONG,
//   WEEKDAYS_SHORT,
// } from '../../utils/dates'

// const FORMAT = 'dd.MM.yyyy'
// const PLACEHOLDER = 'dd.mm.åååå'

const DatePickerRange = ({
  value,
  label,
  invalidMessage,
  validation,
  maxDate,
  disabled,
  disabledTitle,
  onChange,
  onBlur,
  css,
  maxWidth = 550,
  minWidth = 550
}) => {
  // const isMobile = useIsMobile()

  // const fromPickerRef = useRef<DayPickerInput>(null)
  // const toPickerRef = useRef<DayPickerInput>(null)

  // const currentYear = new Date().getFullYear()

  // const maxDateAvailable = maxDate
  //   ? new Date(maxDate)
  //   : new Date(currentYear + 5, 11, 31)

  // const [dates, setDates] = useState<{ to?: Date; from?: Date }>({
  //   to: undefined,
  //   from: undefined,
  // })

  // useEffect(() => {
  //   if (isMobile && fromPickerRef)
  //     (fromPickerRef as any).current.input.readOnly = true
  // }, [isMobile, fromPickerRef])

  // useEffect(() => {
  //   if (isMobile && toPickerRef)
  //     (toPickerRef.current as any).input.readOnly = true
  // }, [isMobile, toPickerRef])

  // const modifiers: Partial<Modifiers> = { start: dates.from, end: dates.to }

  // const pickerPropsDefault = {
  //   locale: 'no',
  //   months: MONTHS,
  //   weekdaysLong: WEEKDAYS_LONG,
  //   weekdaysShort: WEEKDAYS_SHORT,
  //   firstDayOfWeek: 1,
  //   // custom
  //   modifiers,
  //   numberOfMonths: 2,
  //   selected: [dates.from, { from: dates.from, to: dates.to }],
  // }

  // const toDayProps = {
  //   ...pickerPropsDefault,
  //   disabled: { before: dates.from } as Modifier,
  //   month: dates.from,
  //   fromMonth: dates.from,
  // }

  // const fromDayProps = {
  //   ...pickerPropsDefault,
  //   disabled: { after: dates.to } as Modifier,
  //   toMonth: dates.to,
  //   onDayClick: () => toPickerRef.current?.getInput().focus(),
  // }

  // const handleChange = (key: 'to' | 'from') => (date: Date) => {
  //   setDates((prev) => ({ ...prev, [key]: date }))
  //   onChange({ ...dates, [key]: date })
  // }

  return (0, _jsxRuntime.jsx)(_styles.Wrapper, {
    css: () => [_styles.styles.wrapper(maxWidth, minWidth), css && css],
    children: (0, _jsxRuntime.jsxs)(_styles.Input, {
      className: "InputFromTo",
      title: disabled?.from && disabledTitle?.from ? disabledTitle?.from : undefined,
      css: theme => [_styles.styles.default(theme), validation && _styles.styles.validation, invalidMessage && _styles.styles.invalid(theme)],
      children: [label?.from && (0, _jsxRuntime.jsx)(_styles.Label, {
        children: label.from
      }), invalidMessage?.to && (0, _jsxRuntime.jsx)(_IconErrorOutline.default, {
        size: "16px"
      }), invalidMessage && (0, _jsxRuntime.jsx)(_styles.ErrorMessage, {
        children: invalidMessage?.to
      })]
    })
  });
};
var _default = exports.default = DatePickerRange;